module.exports = __webpack_public_path__ + "static/media/alpine-combined.f8c80bd4.png";